var exports = {
  "item": "xf0b3b88a--4834e6--item",
};

module.exports = exports;
